import 'react';
export { applyStylesIntoShadowRoot } from './chunk-OYQZYDWN.js';
//# sourceMappingURL=shadowDomStyles-3VGT4BIW.js.map
//# sourceMappingURL=shadowDomStyles-3VGT4BIW.js.map